<div class="string-format-selector">

  <button (click)="onFormatSelected(StringFormatType.UPPER)"
          [ngClass]="{'format-selected': selectedFormat===StringFormatType.UPPER}"
          [disabled]="disabled"
          matTooltip="Enforce all upper case">
    <span class="material-symbols-outlined">uppercase</span>
  </button>


  <button (click)="onFormatSelected(StringFormatType.LOWER)"
          [ngClass]="{'format-selected': selectedFormat===StringFormatType.LOWER}"
          [disabled]="disabled"
          matTooltip="Enforce all lower case">
    <span class="material-symbols-outlined">lowercase</span>
  </button>


  <button (click)="onFormatSelected(null)"
          [ngClass]="{'format-selected': selectedFormat===null}"
          [disabled]="disabled"
          matTooltip="Allow mixed case formatting">
    <span class="material-symbols-outlined">match_case</span>
  </button>

</div>
